import { Permission } from './permission.model';

export class Role {
  public RoleID: number;
  public Name: string;
  public Type: string;
  public Permissions: Array<Permission>;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
